import api from './api';

const BASE = '/api/membership-plans';

export const getMembershipPlans = () => api.get(BASE);

export const createMembershipPlan = (payload) => api.post(BASE, payload);

export const updateMembershipPlan = (id, payload) => api.put(`${BASE}/${id}`, payload);

export const toggleArchiveMembershipPlan = (id) => api.patch(`${BASE}/${id}/archive`);

export const assignMembershipPlan = (payload) => api.post(`${BASE}/assign`, payload);
